import _message from "antd/es/message";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import axios from 'axios';
import devTool from 'fe-dev-tool';
import { traceOnError } from '../tracer';
function successHandle(result) {
  var response = result.data;
  if (_typeof(response) !== 'object') return response;
  if (response.code >= 200 && response.code <= 299) {
    return response;
  }
  if (response.code === 401) {
    window.location.href = "/accounts/login?next=".concat(encodeURIComponent(window.location.href));
    return Promise.reject(response);
  }
  return Promise.reject(response);
}
function errorHandle(error) {
  traceOnError(error.message, error.code, JSON.stringify(error));
  var response = error.response;
  var reject = {};
  if (response && response.data) {
    var _response$data$res = response.data.res,
      res = _response$data$res === void 0 ? {} : _response$data$res;
    reject = {
      code: res.code,
      message: res.message
    };
  }
  if (response && !response.data) {
    reject = {
      code: response.status,
      message: response.statusText
    };
  }
  if (!response) {
    reject = {
      code: 400,
      message: error.message
    };
  }
  // 有些时候，Python服务器返回500 但message却是OK
  if (reject.code === 500) {
    reject.message = '服务器错误';
  }
  return Promise.reject(reject);
}
var baseURL = devTool.apiPathTransform(process.env.BROWSER_REQUEST_PREFIEX || '/');
axios.defaults.baseURL = baseURL;
if (!/\/$/.test(baseURL)) baseURL = "".concat(baseURL, "/");
var Client = /*#__PURE__*/function () {
  function Client() {
    _classCallCheck(this, Client);
    var axiosClient = axios.create(Client.clientConfig);
    if (Client.clientConfig.retry) {
      axiosClient.interceptors.response.use(successHandle, this.retriedErrorHandle.bind(this));
    } else {
      axiosClient.interceptors.response.use(successHandle, errorHandle);
    }
    this.client = axiosClient;
    this.times = 0;
  }
  _createClass(Client, [{
    key: "retriedErrorHandle",
    value: function retriedErrorHandle(error) {
      var _this = this;
      var _Client$clientConfig = Client.clientConfig,
        retryTimes = _Client$clientConfig.retryTimes,
        backOffDelay = _Client$clientConfig.backOffDelay;
      if (/timeout/i.test(error.message)) {
        if (++this.times <= retryTimes) {
          if (backOffDelay) {
            _message.info("Request failed. Will retry after ".concat(backOffDelay / 1000, "s..."));
          }
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve();
            }, backOffDelay);
          }).then(function () {
            return _this.client(error.config);
          });
        }
        // eslint-disable-next-line
        return Promise.reject({
          code: 500,
          message: 'request timeout'
        });
      }
      return errorHandle(error);
    }
  }, {
    key: "get",
    value: function get(url, params) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var defaultOpt = {
        url: url,
        params: params,
        method: 'get',
        skipNotice: true // 请求失败在页面是否显示提示消息
      };

      return this.client.request(Object.assign(defaultOpt, option));
    }
  }, {
    key: "post",
    value: function post(url, data) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var defaultOpt = {
        url: url,
        data: data,
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        skipNotice: true
      };
      return this.client.request(Object.assign(defaultOpt, option));
    }
  }, {
    key: "update",
    value: function update(url, file) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var formData = new FormData();
      formData.append('file', file);
      var defaultOpt = {
        url: url,
        data: formData,
        method: 'post',
        skipNotice: true
      };
      return this.client.request(Object.assign(defaultOpt, option));
    }
  }, {
    key: "patch",
    value: function patch(url, data) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var defaultOpt = {
        url: url,
        data: data,
        method: 'patch',
        headers: {
          'Content-Type': 'application/json'
        },
        skipNotice: true
      };
      return this.client.request(Object.assign(defaultOpt, option));
    }
  }]);
  return Client;
}();
_defineProperty(Client, "clientConfig", {
  baseURL: baseURL,
  timeout: process.env.BROWSER_REQUEST_TIMEOUT,
  // add timeout retry
  retry: true,
  backOffDelay: 3000,
  retryTimes: 3
});
export { Client as default };